import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Field from 'containers/request/Payments/LabeledField';
import { formatCurrency } from 'helpers/StringHelper';
import { formatDate } from 'helpers/DateHelper';

const RequestDetails = ({ request }) => {
  const {
    id,
    tn,
    vendor,
    invoice,
    typeTitle,
    billingPocName,
    billingPocPhone,
    billingPocEmail,
    billingAddress,
    billingCompanyName,
    modelName
  } = request;

  const details = [
    {
      id: 'requestId',
      label: 'Request Id',
      content: <Link to={`/accountant/requests/${id}`}>{tn}</Link>
    },
    {
      id: 'modelName',
      label: 'Model Name / Number',
      content: modelName
    },
    {
      id: 'vendor',
      label: 'Manufacturer',
      content: vendor
    },
    {
      id: 'requestType',
      label: 'Request Type',
      content: typeTitle
    },
    {
      id: 'billingCompany',
      label: 'Billing Company',
      labelStyle: 'primary',
      content: billingCompanyName
    },
    {
      id: 'billingAddress',
      label: 'Billing Address',
      labelStyle: 'primary',
      content: billingAddress
    },
    {
      id: 'billingPOC',
      label: 'Billing PoC',
      labelStyle: 'primary',
      content: billingPocName
    },
    {
      id: 'billingPhone',
      label: 'Billing Phone',
      labelStyle: 'primary',
      content: billingPocPhone
    },
    {
      id: 'billingEmail',
      label: 'Billing Email',
      labelStyle: 'primary',
      content: billingPocEmail
    },
    {
      id: 'invoiceId',
      label: 'Invoice #',
      content: tn
    },
    {
      id: 'invoiceDate',
      label: 'Invoice Date',
      content: formatDate(invoice.createdat)
    },
    {
      id: 'invoiceAmount',
      label: 'Invoice Amount',
      content: formatCurrency(invoice.totalamount)
    }
  ];

  const renderDetails = () =>
    details.map(field => {
      return <Field {...field} key={field.id} />;
    });

  return <Form horizontal>{renderDetails()}</Form>;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestDetails);



// WEBPACK FOOTER //
// ./src/containers/request/Payments/RequestDetails.js